import { render } from "./IsoHotel.vue?vue&type=template&id=b29ebaa0&scoped=true"
import script from "./IsoHotel.vue?vue&type=script&lang=js"
export * from "./IsoHotel.vue?vue&type=script&lang=js"

import "./IsoHotel.vue?vue&type=style&index=0&id=b29ebaa0&scoped=true&lang=css"
import "./IsoHotel.vue?vue&type=style&index=1&id=b29ebaa0&scoped=true&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b29ebaa0"]])

export default __exports__